import StepsIndicator from '../steps-indicator'
import { Input } from '../ui'
import { PasswordInput } from '../ui/password-input'
import { Alert, AlertDescription } from '../ui/alert'
import { Button } from '../ui/button'
import { Card } from '../ui/card'
import { Label } from '@/components/ui/label'

interface SetupPasswordProps {
  setPassword: (password: string) => void
  setConfirmPassword: (confirmPassword: string) => void
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  isLoading?: boolean
  formError?: string
}

export function SetupPassword({
  setPassword,
  setConfirmPassword,
  handleSubmit,
  isLoading,
  formError,
}: SetupPasswordProps) {
  return (
    <div className="w-full min-h-screen flex items-center justify-center relative">
      {/* add the fanfair logo to the top left of the page */}
      <div className="absolute top-6 left-6 pt-4">
        <img src="/fanfair.png" alt="FanFair" className="h-20" />
      </div>
      <div className="w-full max-w-5xl  rounded-2xl overflow-hidden">
        <div className="">
          {/* Right Panel - Login Form */}
          <div className="w-full flex items-center justify-center lg:p-12">
            <div className="w-full max-w-xs space-y-1 ">
              {/* Mobile Header */}
              <div className="lg:hidden text-center">
                <img src="/fanfairreversed.png" alt="FanFair" className="h-8 mx-auto" />
              </div>
              <div className="space-y-1 text-center">
                <h1 className="font-lato text-[23px] font-medium text-black">
                  Complete Your Registration.
                </h1>
              </div>
              <div>
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-col w-full gap-3">
                    <div className="flex flex-col gap-4 mt-3">
                      <div className="flex flex-col gap-2">
                        <PasswordInput
                          className="bg-white border-primary text-black placeholder-slate-400 focus:border-primary focus:ring-primary/20"
                          placeholder="Enter Your Password"
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          disabled={isLoading}
                          data-testid="password-input"
                        />
                      </div>
                      <div className="flex flex-col gap-2">
                        <PasswordInput
                          className="bg-white border-primary text-black placeholder-slate-400 focus:border-primary focus:ring-primary/20"
                          placeholder="Re-enter Your Password"
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                          disabled={isLoading}
                          data-testid="confirm-password-input"
                        />
                        {/*<p className="text-gray-300 text-xs">Both passwords must match</p>*/}
                      </div>
                    </div>
                    <div>
                        {formError && (
                          <div className="mt-1">
                            <span className="text-[#BB33FF] text-xs">{formError}</span>
                          </div>
                        )}
                      </div>
                    <Button
                      type="submit"
                      disabled={isLoading}
                      className="w-full bg-[#570393] hover:bg-[#570393]/90 text-white"
                    >
                      {isLoading ? 'Setting Password...' : 'Set Password'}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 right-6">
        <img src="/green-tickets.png" alt="Green Tickets" className="h-[300px]" />
      </div>
    </div>
  )
}
